<!-- コースマスタ　詳細画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wirks">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>コースマスタ<span>詳細</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<table class="inputTbl">
					<caption>
						<ul class="listClass">
							<li><b>クライアント名</b>{{jgnm}}</li>
						</ul>
						<div class="btnLst">
								<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
						</div>
					</caption>
					<thead>
						<tr>
							<th>項目名称</th>
							<td>登録内容</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>年度</th>
							<td class="dateY"><input type="text" placeholder="XXXX" v-model="inputForm.nend" disabled>年度</td>
						</tr>
						<tr>
							<th>予約登録<br>開始日/終了日</th>
							<td>
								<dl class="dayForm">
									<dt>開始日</dt>
									<dd>
										<ul>
											<li>
												<select v-model="inputForm.stdyYear">
													<option value=0></option>
													<option v-for="item in inputForm.listStdyYear" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.stdyMonth">
													<option value=0></option>
													<option v-for="item in inputForm.listStdyMonth" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<!-- 選んだ予約登録開始日　年及び月に依存 -->
												<select v-model="inputForm.stdyDate">
													<option value=0></option>
													<option v-for="item in computedListStdyDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
									</dd>
									<dt>終了日</dt>
									<dd>
										<ul>
											<li>
												<select v-model="inputForm.eddyYear">
													<option value=0></option>
													<option v-for="item in inputForm.listEddyYear" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<select v-model="inputForm.eddyMonth">
													<option value=0></option>
													<option v-for="item in inputForm.listEddyMonth" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
											<li>
												<!-- 選んだ予約登録終了日　年及び月に依存 -->
												<select v-model="inputForm.eddyDate">
													<option value=0></option>
													<option v-for="item in computedListEddyDate" v-bind:key="item">
														{{item}}
													</option>
												</select>
											</li>
										</ul>
									</dd>
								</dl>
							</td>
						</tr>
						<tr>
							<th>名称</th>
							<td><input type="text" placeholder="名称" v-model="inputForm.ksnm"></td>
						</tr>
						<tr>
							<th>内部名称</th>
							<td><input type="text" placeholder="内部名称" v-model="inputForm.nbnm"></td>
						</tr>
						<tr>
							<th>所要時間</th>
							<td><input type="text" placeholder="所要時間" v-model="inputForm.time"></td>
						</tr>
						<tr>
							<th>公開フラグ</th>
							<td>
								<label for="release" class="radio"><input type="radio" id="release" v-bind:value="inputForm.codeUpokPrivate" v-model="inputForm.upok"><span>非公開</span></label>
								<label for="private" class="radio"><input type="radio" id="private" v-bind:value="inputForm.codeUpokPublic" v-model="inputForm.upok"><span>公開</span></label>
							</td>
						</tr>
						<tr>
							<th>コース説明</th>
							<td><textarea placeholder="コース説明" v-model="inputForm.mem1"></textarea></td>
						</tr>
						<tr>
							<th>お勧め対象</th>
							<td><textarea placeholder="お勧め対象" v-model="inputForm.mem2"></textarea></td>
						</tr>
						<tr>
							<th>予約登録時<br>注意事項</th>
							<td><textarea placeholder="予約登録時注意事項" v-model="inputForm.mem3"></textarea></td>
						</tr>
						<tr>
							<th>予約確定時<br>注意事項</th>
							<td><textarea placeholder="予約確定時注意事項" v-model="inputForm.mem4"></textarea></td>
						</tr>
						<tr>
							<th>キャンセル確定時<br>注意事項</th>
							<td><textarea placeholder="キャンセル確定時注意事項" v-model="inputForm.mem5"></textarea></td>
						</tr>
					</tbody>
				</table>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WIRKSDetailApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWIRKSDetail',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow,
		}, 
		// 算出プロパティ
		computed: {
			// 予約登録開始日　日付のプルダウン内容を生成
			computedListStdyDate: function () {

				var tempListStdyDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.stdyYear,
					this.inputForm.stdyMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListStdyDate.push(i)
				}

				return tempListStdyDate
			},
			// 予約登録終了日　日付のプルダウン内容を生成
			computedListEddyDate: function () {

				var tempListEddyDate = []

				// 当月の最終日の求め方
				// 本来8月なら第二引数（月）は7を与えるべきだが
				// 本来8月なら第三引数（日）に0を与えて
				// 次月の最初の日（1日）より一日前（0日）で
				// 当月の最終日を求める
				var lastDate = new Date(
					this.inputForm.eddyYear,
					this.inputForm.eddyMonth, 0).getDate()

				for (var i = 1; i <= lastDate; i++) {
					tempListEddyDate.push(i)
				}

				return tempListEddyDate
			}
		},   
		data() {
			return {
				// クライアント名
				jgnm: '',
				// 入力フォーム
				inputForm: {
					// 年度
					nend: '',
					// 予約登録開始日　年
					stdyYear: 0,
					// 予約登録開始日　月
					stdyMonth: 0,
					// 予約登録開始日　日
					stdyDate: 0,
					// 予約登録開始日　年のプルダウン内容
					listStdyYear:[],
					// 予約登録開始日　月のプルダウン内容
					listStdyMonth: [
						1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
					],
					// 予約登録終了日　年
					eddyYear: 0,
					// 予約登録終了日　月
					eddyMonth: 0,
					// 予約登録終了日　日
					eddyDate: 0,
					// 予約登録終了日　年のプルダウン内容
					listEddyYear:[],
					// 予約登録終了日　月のプルダウン内容
					listEddyMonth: [
						1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
					],
					// 名称
					ksnm: '',
					// 内部名称
					nbnm: '',
					// 所要時間
					time: '',
					// 公開フラグ
					upok: '',
					// 0: 非公開
					codeUpokPrivate: '0',
					// 1: 公開
					codeUpokPublic: '1',
					// コース説明
					mem1: '',
					// お勧め対象
					mem2: '',
					// 予約登録時注意事項
					mem3: '',
					// 予約確定時注意事項
					mem4: '',
					// キャンセル確定時注意事項
					mem5: ''
				},
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		// ライフサイクルフック: created
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWIRKSRegister::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog('MasterWIRKSRegister::created End')
		},
		methods: {
			// イベント系--------------------------------------------------S
			// 初期表示
			firstDisplay: function(){
				UtilityConsoleLog.consoleLog("MasterWIRKSDetail::firstDisplay Start")

				// 非同期通信
				WIRKSDetailApi.FirstDisplay({
					token: this.$store.state.auth.token,
					nend: this.$store.state.adminUserChoice.MasterWIRKS.nend,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd,
					kscd: this.$store.state.adminUserChoice.MasterWIRKS.kscd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.jgnm = responce.data.jgnm
						
						this.inputForm.listStdyYear = responce.data.listYear
						this.inputForm.listEddyYear = responce.data.listYear

						this.inputForm.nend = responce.data.nend
						this.inputForm.stdyYear = responce.data.stdyYear
						this.inputForm.stdyMonth = responce.data.stdyMonth
						this.inputForm.stdyDate = responce.data.stdyDate
						this.inputForm.eddyYear = responce.data.eddyYear
						this.inputForm.eddyMonth = responce.data.eddyMonth
						this.inputForm.eddyDate = responce.data.eddyDate
						this.inputForm.ksnm = responce.data.ksnm
						this.inputForm.nbnm = responce.data.nbnm
						this.inputForm.time = responce.data.time
						this.inputForm.upok = responce.data.upok
						this.inputForm.mem1 = responce.data.mem1
						this.inputForm.mem2 = responce.data.mem2
						this.inputForm.mem3 = responce.data.mem3
						this.inputForm.mem4 = responce.data.mem4
						this.inputForm.mem5 = responce.data.mem5

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKSDetail::firstDisplay End')
				})
			},
			// 更新確認ダイアログ
			onUpdate: function () {
				UtilityConsoleLog.consoleLog("MasterWIRKSDetail::onUpdate Start")

				WIRKSDetailApi.Update({
					token: this.$store.state.auth.token,
					nend: this.$store.state.adminUserChoice.MasterWIRKS.nend,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd,
					kscd: this.$store.state.adminUserChoice.MasterWIRKS.kscd,
					stdyYear: this.inputForm.stdyYear,
					stdyMonth: this.inputForm.stdyMonth,
					stdyDate: this.inputForm.stdyDate,
					eddyYear: this.inputForm.eddyYear,
					eddyMonth: this.inputForm.eddyMonth,
					eddyDate: this.inputForm.eddyDate,
					ksnm: this.inputForm.ksnm,
					nbnm: this.inputForm.nbnm,
					time: this.inputForm.time,
					upok: this.inputForm.upok,
					mem1: this.inputForm.mem1,
					mem2: this.inputForm.mem2,
					mem3: this.inputForm.mem3,
					mem4: this.inputForm.mem4,
					mem5: this.inputForm.mem5
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 更新確認モーダルを閉じる
						this.onConfirmUpdateModalClose()
						// 更新完了モーダルを開く
						this.$router.push("/MasterWIRKSDetailUpdate")

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
						// 入力項目（単項目）でのエラー
						// 入力エラーダイアログの出力
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {
						// 入力項目（相関項目）でのエラー
						// 入力エラーダイアログの出力
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onUpdate End')
				})
			},
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWIRKSDetail::onCancel Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WIRKS_BACKTOLIST)

				this.$router.push("/MasterWIRKSList")

				UtilityConsoleLog.consoleLog("MasterWIRKSDetail::onCancel End")
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWKSWK::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWKSWK::checkNumber End')

				return tempValue
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push('/AdminLogin')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalOpen Start')

				// 整数型の型を確認する
				var tempnend = this.checkNumber(this.inputForm.nend)
				if(tempnend == -1) {
					this.onValidationErrorModalOpen(
						['年度は整数で入力してください。'])
					return
				}

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::onConfirmUpdateModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWIRKSDetail::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKS/MasterWIRKSDetail.vue